<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <div>
          <material-card>
            <ValidationObserver ref="form" v-slot="{ passes }">
              <v-form @submit.prevent="passes(save)">
                <v-card>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md6 v-for="model in models" :key="model.key">
                          <v-switch
                            v-if="model.key=='DirectOTApproval'"
                            v-model="model.value"
                            :label="getLabel(model.key)"
                          ></v-switch>
                          <ValidationProvider
                            v-else
                            :name="getLabel(model.key)"
                            rules="required|numeric"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="model.value"
                              :label="getLabel(model.key)"
                              :error-messages="errors[0]"
                            />
                          </ValidationProvider>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="blue darken-1" text type="submit">{{$t('language.save')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </ValidationObserver>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import Base from "../../../shared/Base.vue";
export default {
  name: "overtimesetupview",
  extends: Base,
  created() {
    this.vModel = [];
    this.url = "client/setup/ots";
  },
  data(){
    return {
      models : []
    };
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/setup/ots").then(response => {
      next(p => {
        p.models = response.data.map((item) => {
                if (item.key == "DirectOTApproval")
                    item.value = item.value == 'true';
                return item;
            });
        p.isEdit = true;
      });
    });
  },
  methods: {
    getLabel(key) {
      return this.$t("language." + key.toLowerCase());
    },
    beforeSave(){
      this.vModel = this.models.map((item) => {
          let returnitem = {
            key : item.key,
            value : item.value
          }
          if (returnitem.key == "DirectOTApproval")
              returnitem.value = returnitem.value ? 'true' : 'false';
          return returnitem;
      });
      return true;
    }
  }
};
</script>